(function () {
  const showCollapsibleContent = () => {
    $(".collapsible-content").each(function () {
      const section = $(this);
      const items = section.find(".collapsible-content-item");

      items.each(function () {
        const trigger = $(this).find(".collapsible-content-summery");
        const content = $(this).find(".collapsible-content-block__description");

        trigger.off("click").on("click", function () {
          const isActive = $(this).hasClass("active");

          // Zatvori sve unutar ove sekcije
          items.find(".collapsible-content-summery").removeClass("active");
          items.find(".collapsible-content-block__description").slideUp(300);

          // Ako kliknuti nije bio aktivan, otvori ga
          if (!isActive) {
            $(this).addClass("active");
            content.stop().slideDown(300);
          }
        });
      });
    });
  };

  $(document).ready(showCollapsibleContent);
})();
